import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import axios from '../../../../services/AxiosInstance';
import swal from "sweetalert";
import { useForm } from "react-hook-form";


const EditRate = (props) =>{
    
    //const userdetails = JSON.parse(localStorage.getItem('userDetails'));
    const { register, handleSubmit,setValue, watch, formState: { errors } } = useForm();
    let history = useHistory();
    const onSubmit = (data) => {
        //console.log(data);
        //axios.defaults.headers.common['Authorization'] = `Bearer ${userdetails.idToken}`;
        //axios.defaults.headers.post['Content-Type'] = 'application/json';
        axios.put(`/department/departmasters/` + props.match.params.id, data)
        .then(res => {
            if (res.status === 200){
                swal("Department updated successfully", "success");
                history.push("/department-master");
            }else{
                Promise.reject()
            }
        })
        .catch(err => {
            console.log( err.message);
            swal("Something went wrong", "error");
        });
    };
    // Load data from server and reinitialize student form
    useEffect(() => {
        //axios.defaults.headers.common['Authorization'] = `Bearer ${userdetails.idToken}`;
        //axios.defaults.headers.post['Content-Type'] = 'application/json';
        axios
        .get(
            `/department/edit-department/` 
            + props.match.params.id
        )
        .then((res) => {
            setValue('departname', res.data.departname);
            console.log("Edit Department");
            console.log(res.data);
        })
        .catch((err) => console.log(err));
    }, []);
    return(
        <Fragment>
            <PageTitle activeMenu="Edit Department" motherMenu="Users" />
            <div className="row">
                <div className="col-xl-6 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                        <h4 className="card-title">Edit Department</h4>
                        </div>
                        <div className="card-body">
                        <div className="basic-form">
                            <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">Department Name</label>
                                <div className="col-sm-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Department Name"
                                    {...register("departname", { required: true })}
                                />
                                {errors.departname?.type === 'required' && "Department name is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <div className="col-sm-12">
                                    <button type="submit" className="btn btn-primary float-end">
                                        Submit
                                    </button>
                                </div>
                            </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>          
            </div>
        </Fragment>
    )
}

export default EditRate;